import React from "react"
import { Modal } from "react-bootstrap"

export default function PlaceholdersModal({ show, onHide, placeholders = [] }) {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <h2 className="modal-title">Placeholders</h2>
      </Modal.Header>
      <div className="modal-body">
        <table className="table table-listing">
          <thead>
            <tr>
              <th>Placeholder</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {placeholders.map(item => (
              <tr key={item.token}>
                <td>{`%{${item.token}}`}</td>
                <td>{item.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  )
}
